<div class="card-sort-pills" role="group" [attr.aria-label]="ariaLabel()">
    @for (opcao of opcoes(); track opcao.field) {
        <button
            type="button"
            class="card-sort-pill"
            [class.card-sort-pill-active]="isAtivo(opcao.field)"
            [attr.aria-label]="aria(opcao.label, opcao.field)"
            [attr.aria-pressed]="isAtivo(opcao.field)"
            (click)="onPillClick(opcao.field)"
        >
            <span>{{ opcao.label }}</span>
            <i [class]="iconeClass(opcao.field)" aria-hidden="true"></i>
        </button>
    }
</div>
